import { render } from "./Claim1.vue?vue&type=template&id=6f3fd576&scoped=true"
import script from "./Claim1.vue?vue&type=script&lang=js"
export * from "./Claim1.vue?vue&type=script&lang=js"

import "./Claim1.vue?vue&type=style&index=0&id=6f3fd576&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6f3fd576"

export default script